var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "scrollbar-inner" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h4", { staticClass: "h3 mb-0" }, [
            _vm._v("\n        Multi User Picker\n        "),
            _c(
              "span",
              {
                attrs: {
                  "data-toggle": "tooltip",
                  "data-placement": "bottom",
                  title:
                    "Share this task with others using CCed just like email, but they are not responsible for the task. Search will search you entire network, but this list shows currently, then recently then project team members first.",
                },
              },
              [_c("i", { staticClass: "far fa-question-circle" })]
            ),
          ]),
        ]),
        _c("div", { staticClass: "card-header py-0" }, [
          _c("form", [
            _c("div", { staticClass: "form-group mb-0" }, [
              _c(
                "div",
                { staticClass: "input-group input-group-lg input-group-flush" },
                [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c("div", { staticClass: "input-group-text" }, [
                      _c("span", { staticClass: "fas fa-search" }),
                    ]),
                  ]),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "search", placeholder: "Search" },
                  }),
                ]
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "card-body px-2 py-3" }, [
          _c("ul", { staticClass: "list-group list-group-flush list my--3" }, [
            _c("li", { staticClass: "list-group-item px-0" }, [
              _c("div", { staticClass: "row align-items-center mx-1" }, [
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c(
                    "a",
                    {
                      staticClass: "avatar avatar-sm rounded-circle",
                      attrs: { href: "#" },
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "Image placeholder",
                          src: require("../../../assets/img/theme/team-1.jpg"),
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "col ml-1 px-1" }, [
                  _c("h5", { staticClass: "mb-0" }, [
                    _c("a", { staticClass: "d-block", attrs: { href: "#!" } }, [
                      _vm._v("Rayan Thomson"),
                    ]),
                  ]),
                  _c("span", { staticClass: "text-success" }, [_vm._v("●")]),
                  _c("small", [_vm._v("Online")]),
                ]),
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c("label", { staticClass: "custom-toggle" }, [
                    _c("input", { attrs: { type: "checkbox", checked: "" } }),
                    _c("span", {
                      staticClass: "custom-toggle-slider rounded-circle",
                      attrs: { "data-label-off": "OFF", "data-label-on": "ON" },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("li", { staticClass: "list-group-item px-0" }, [
              _c("div", { staticClass: "row align-items-center mx-1" }, [
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c(
                    "a",
                    {
                      staticClass: "avatar avatar-sm rounded-circle",
                      attrs: { href: "#" },
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "Image placeholder",
                          src: require("../../../assets/img/theme/team-2.jpg"),
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "col ml-1 px-1" }, [
                  _c("h5", { staticClass: "mb-0" }, [
                    _c("a", { staticClass: "d-block", attrs: { href: "#!" } }, [
                      _vm._v("Romina Hadid"),
                    ]),
                  ]),
                  _c("span", { staticClass: "text-success" }, [_vm._v("●")]),
                  _c("small", [_vm._v("Online")]),
                ]),
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c("label", { staticClass: "custom-toggle" }, [
                    _c("input", { attrs: { type: "checkbox", checked: "" } }),
                    _c("span", {
                      staticClass: "custom-toggle-slider rounded-circle",
                      attrs: { "data-label-off": "OFF", "data-label-on": "ON" },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("li", { staticClass: "list-group-item px-0" }, [
              _c("div", { staticClass: "row align-items-center mx-1" }, [
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c(
                    "a",
                    {
                      staticClass: "avatar avatar-sm rounded-circle",
                      attrs: { href: "#" },
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "Image placeholder",
                          src: require("../../../assets/img/theme/team-3.jpg"),
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "col ml-1 px-1" }, [
                  _c("h5", { staticClass: "mb-0" }, [
                    _c("a", { staticClass: "d-block", attrs: { href: "#!" } }, [
                      _vm._v("Alexander Smith"),
                    ]),
                  ]),
                  _c("span", { staticClass: "text-danger" }, [_vm._v("●")]),
                  _c("small", [_vm._v("Offline")]),
                ]),
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c("label", { staticClass: "custom-toggle" }, [
                    _c("input", { attrs: { type: "checkbox", checked: "" } }),
                    _c("span", {
                      staticClass: "custom-toggle-slider rounded-circle",
                      attrs: { "data-label-off": "OFF", "data-label-on": "ON" },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("li", { staticClass: "list-group-item px-0" }, [
              _c("div", { staticClass: "row align-items-center mx-1" }, [
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c(
                    "a",
                    {
                      staticClass: "avatar avatar-sm rounded-circle",
                      attrs: { href: "#" },
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "Image placeholder",
                          src: require("../../../assets/img/theme/team-1.jpg"),
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "col ml-1 px-1" }, [
                  _c("h5", { staticClass: "mb-0" }, [
                    _c("a", { staticClass: "d-block", attrs: { href: "#!" } }, [
                      _vm._v("Suman Khatiwada"),
                    ]),
                  ]),
                  _c("span", { staticClass: "text-danger" }, [_vm._v("●")]),
                  _c("small", [_vm._v("Offline")]),
                ]),
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c("label", { staticClass: "custom-toggle" }, [
                    _c("input", { attrs: { type: "checkbox", checked: "" } }),
                    _c("span", {
                      staticClass: "custom-toggle-slider rounded-circle",
                      attrs: { "data-label-off": "OFF", "data-label-on": "ON" },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("li", { staticClass: "list-group-item px-0" }, [
              _c("div", { staticClass: "row align-items-center mx-1" }, [
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c(
                    "a",
                    {
                      staticClass: "avatar avatar-sm rounded-circle",
                      attrs: { href: "#" },
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "Image placeholder",
                          src: require("../../../assets/img/theme/team-1.jpg"),
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "col ml-1 px-1" }, [
                  _c("h5", { staticClass: "mb-0" }, [
                    _c("a", { staticClass: "d-block", attrs: { href: "#!" } }, [
                      _vm._v("Michael Simonetti"),
                    ]),
                  ]),
                  _c("span", { staticClass: "text-success" }, [_vm._v("●")]),
                  _c("small", [_vm._v("Online")]),
                ]),
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c("label", { staticClass: "custom-toggle" }, [
                    _c("input", { attrs: { type: "checkbox" } }),
                    _c("span", {
                      staticClass: "custom-toggle-slider rounded-circle",
                      attrs: { "data-label-off": "OFF", "data-label-on": "ON" },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("li", { staticClass: "list-group-item px-0" }, [
              _c("div", { staticClass: "row align-items-center mx-1" }, [
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c(
                    "a",
                    {
                      staticClass: "avatar avatar-sm rounded-circle",
                      attrs: { href: "#" },
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "Image placeholder",
                          src: require("../../../assets/img/theme/team-1.jpg"),
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "col ml-1 px-1" }, [
                  _c("h5", { staticClass: "mb-0" }, [
                    _c("a", { staticClass: "d-block", attrs: { href: "#!" } }, [
                      _vm._v("Michael Simonetti"),
                    ]),
                  ]),
                  _c("span", { staticClass: "text-success" }, [_vm._v("●")]),
                  _c("small", [_vm._v("Online")]),
                ]),
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c("label", { staticClass: "custom-toggle" }, [
                    _c("input", { attrs: { type: "checkbox" } }),
                    _c("span", {
                      staticClass: "custom-toggle-slider rounded-circle",
                      attrs: { "data-label-off": "OFF", "data-label-on": "ON" },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("li", { staticClass: "list-group-item px-0" }, [
              _c("div", { staticClass: "row align-items-center mx-1" }, [
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c(
                    "a",
                    {
                      staticClass: "avatar avatar-sm rounded-circle",
                      attrs: { href: "#" },
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "Image placeholder",
                          src: require("../../../assets/img/theme/team-1.jpg"),
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "col ml-1 px-1" }, [
                  _c("h5", { staticClass: "mb-0" }, [
                    _c("a", { staticClass: "d-block", attrs: { href: "#!" } }, [
                      _vm._v("Michael Simonetti"),
                    ]),
                  ]),
                  _c("span", { staticClass: "text-success" }, [_vm._v("●")]),
                  _c("small", [_vm._v("Online")]),
                ]),
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c("label", { staticClass: "custom-toggle" }, [
                    _c("input", { attrs: { type: "checkbox" } }),
                    _c("span", {
                      staticClass: "custom-toggle-slider rounded-circle",
                      attrs: { "data-label-off": "OFF", "data-label-on": "ON" },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("li", { staticClass: "list-group-item px-0" }, [
              _c("div", { staticClass: "row align-items-center mx-1" }, [
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c(
                    "a",
                    {
                      staticClass: "avatar avatar-sm rounded-circle",
                      attrs: { href: "#" },
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "Image placeholder",
                          src: require("../../../assets/img/theme/team-1.jpg"),
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "col ml-1 px-1" }, [
                  _c("h5", { staticClass: "mb-0" }, [
                    _c("a", { staticClass: "d-block", attrs: { href: "#!" } }, [
                      _vm._v("Michael Simonetti"),
                    ]),
                  ]),
                  _c("span", { staticClass: "text-success" }, [_vm._v("●")]),
                  _c("small", [_vm._v("Online")]),
                ]),
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c("label", { staticClass: "custom-toggle" }, [
                    _c("input", { attrs: { type: "checkbox" } }),
                    _c("span", {
                      staticClass: "custom-toggle-slider rounded-circle",
                      attrs: { "data-label-off": "OFF", "data-label-on": "ON" },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("li", { staticClass: "list-group-item px-0" }, [
              _c("div", { staticClass: "row align-items-center mx-1" }, [
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c(
                    "a",
                    {
                      staticClass: "avatar avatar-sm rounded-circle",
                      attrs: { href: "#" },
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "Image placeholder",
                          src: require("../../../assets/img/theme/team-1.jpg"),
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "col ml-1 px-1" }, [
                  _c("h5", { staticClass: "mb-0" }, [
                    _c("a", { staticClass: "d-block", attrs: { href: "#!" } }, [
                      _vm._v("Michael Simonetti"),
                    ]),
                  ]),
                  _c("span", { staticClass: "text-success" }, [_vm._v("●")]),
                  _c("small", [_vm._v("Online")]),
                ]),
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c("label", { staticClass: "custom-toggle" }, [
                    _c("input", { attrs: { type: "checkbox" } }),
                    _c("span", {
                      staticClass: "custom-toggle-slider rounded-circle",
                      attrs: { "data-label-off": "OFF", "data-label-on": "ON" },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("li", { staticClass: "list-group-item px-0" }, [
              _c("div", { staticClass: "row align-items-center mx-1" }, [
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c(
                    "a",
                    {
                      staticClass: "avatar avatar-sm rounded-circle",
                      attrs: { href: "#" },
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "Image placeholder",
                          src: require("../../../assets/img/theme/team-1.jpg"),
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "col ml-1 px-1" }, [
                  _c("h5", { staticClass: "mb-0" }, [
                    _c("a", { staticClass: "d-block", attrs: { href: "#!" } }, [
                      _vm._v("Michael Simonetti"),
                    ]),
                  ]),
                  _c("span", { staticClass: "text-success" }, [_vm._v("●")]),
                  _c("small", [_vm._v("Online")]),
                ]),
                _c("div", { staticClass: "col-auto px-1" }, [
                  _c("label", { staticClass: "custom-toggle" }, [
                    _c("input", { attrs: { type: "checkbox" } }),
                    _c("span", {
                      staticClass: "custom-toggle-slider rounded-circle",
                      attrs: { "data-label-off": "OFF", "data-label-on": "ON" },
                    }),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }